import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { cca_config } from '../plugins/cca-config'

// A service/capability rejection is not evidence that the Config login expired.
// Never retry the original business request (in particular patient/payment writes).
const pending = new Map()
export default async function guardSession(error, token) {
    const config = error.config || {}
    const current = () => store.getters.authInfo && store.getters.authInfo.access_token
    if (!error.response || error.response.status !== 401 || !token || current() !== token ||
        config.med005_scoped_access || config.med_access_scoped ||
        (config.med005_access_request && config.url === '/consultations/reattribution-access')) return
    if (pending.has(token)) return pending.get(token)
    const check = (async () => {
        try {
            await axios.post(cca_config.C_URL + cca_config.C_URL_CONFIG_API + '/verify-token', {}, {
                headers: { Authorization: 'Bearer ' + token, Accept: 'application/json' }, timeout: 10000
            })
        } catch (verificationError) {
            if (verificationError.response && verificationError.response.status === 401 && current() === token) {
                store.commit('SET_CREDENTIALS', null)
                store.commit('SET_ACTIVE_ROLE', null)
                localStorage.removeItem('vuex')
                router.push('/login')
            }
        }
    })()
    pending.set(token, check)
    try { await check } finally { pending.delete(token) }
}
